module.exports = __webpack_public_path__ + "static/media/newsletter-december-2018-icon.f8991edb.jpg";